import React from 'react';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const useStyles = makeStyles({
  icon: {
    color: '#ffffff',
    fontSize: 65,
  },
});

const CustomButton = withStyles({
  root: {
    width: 123,
    height: 123,
    borderRadius: '50%',
    backgroundColor: '#6f9594',
    boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.25)',
    margin: 20,
    '&:hover': {
      backgroundColor: '#3a9c99',
    },
  },
})(Button);

const AddButton = () => {
  const classes = useStyles();

  return (
    <CustomButton component="span" disableFocusRipple>
      <AddRoundedIcon classes={{ root: classes.icon }} />
    </CustomButton>
  );
};

export default AddButton;
